/**
 * 专区下车辆配置
 */
import React, { Component } from 'react';
import { Modal, Transfer } from 'antd';

import http from '../../../axios/http';
import messager from '../../ui/messager';

class SpecialVehicle extends Component {

    state = {
        dataSource: [],
        targetKeys: [],
    }

    initData = (specialId, callback) => {
        //读取已设置的商户信息
        http.get({
            url: '/mallSpecial/findSpecialVehicle',
            data: { specialId: specialId },
            success: (res) => {
                let all = [];
                if (res.all != null && res.all.length > 0) {
                    for (let i = 0; i < res.all.length; i++) {
                        all.push({
                            key: res.all[i].id,
                            title: res.all[i].name + "[" + res.all[i].vin + "]",
                            description: res.all[i].id,
                        });
                    }
                }
                this.setState({
                    dataSource: all,
                    targetKeys: res["has"]
                });
                if (callback) {
                    callback(res);
                }
            }
        });
    }

    save = () => {
        let values = {};
        let specialId = this.props.editData.id
        if (specialId !== undefined && specialId != null) {
            values["specialId"] = specialId;
        } else {
            messager.alert("信息丢失，保存失败！", "失败", 'error');
            return;
        }
        values["vehicleIds"] = this.state.targetKeys.join(",");
        http.post({
            url: '/mallSpecial/updateSpecialVehicle',
            data: values,
            success: (res) => {
                this.props.onCancel();
                messager.notify("保存成功！");
            }
        });
    };

    handleChange = (targetKeys, direction, moveKeys) => {
        this.setState({ targetKeys: targetKeys });
    }

    render() {
        const { visible, onCancel } = this.props;
        return (
            <Modal
                width={930}
                visible={visible}
                title="专区车辆配置"
                okText="保存"
                cancelText="取消"
                maskClosable={false}
                onCancel={onCancel}
                onOk={this.save}
                afterClose={() => { this.setState({ targetKeys: [] }) }}
            >
                <Transfer
                    dataSource={this.state.dataSource}
                    showSearch
                    locale={{ itemUnit: '', itemsUnit: '', searchPlaceholder: '车辆名称' }}
                    listStyle={{
                        width: 400,
                        height: 450,
                    }}
                    operations={['添加', '移除']}
                    targetKeys={this.state.targetKeys}
                    onChange={this.handleChange}
                    render={item => `${item.title}`}
                />

            </Modal>
        );
    }
}

export default SpecialVehicle;